import React from "react";
import {Box} from "@mui/material";

interface TagBoxProps {
    text: string;
}

export const TagBox: React.FC<TagBoxProps> = ({ text }) => {
    return <Box sx={{padding: "3px 6px 3px 6px", bgcolor: "#38D59C", width: "fit-content", borderRadius: "8px"}}>
        <span className={"tag-text"}>{ text }</span>
    </Box>;
}